import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { SubscriptionCustomerListItemProps } from '..';
import { HintButton } from '../../../../../../../components/HintButton';
import { LateralBar } from '../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';

export const SubscriptionCustomerListItemTablet: React.FC<SubscriptionCustomerListItemProps> = ({
  subscriptionCustomer,
  quantity,
  setQuantity,
  onSolicit,
  isDisabled,
  disabledMessage,
}) => {
  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy}>
      <Box p="inset.xs" w="full">
        <LateralBar
          backgroundColor="product.rendavariavel"
          borderTopLeftRadius="sm"
          borderBottomLeftRadius="sm"
        />
        <VStack space="stack.xs">
          <HStack justifyContent="space-between">
            <Stack w="1/4">
              <VStack space="stack.quarck">
                <UI.Text variant="semibold" fontSize={Typography['fontsize.xs']}>
                  Cliente
                </UI.Text>
                <UI.Text color="neutral.darkest" variant="semibold">
                  {subscriptionCustomer.customerNameNormalized}
                </UI.Text>
              </VStack>
            </Stack>
            <Stack w="1/4">
              <VStack space="stack.quarck">
                <UI.Text variant="semibold" fontSize={Typography['fontsize.xs']}>
                  Assessor
                </UI.Text>
                <UI.Text color="neutral.darkest" variant="semibold">
                  {subscriptionCustomer.advisorNameNormalized}
                </UI.Text>
              </VStack>
            </Stack>
            <Stack w="1/4">
              <VStack space="stack.quarck">
                <UI.Text variant="semibold" fontSize={Typography['fontsize.xs']}>
                  Telefone
                </UI.Text>
                <UI.Text color="neutral.darkest" variant="semibold">
                  {subscriptionCustomer.phoneNumberNormalized}
                </UI.Text>
              </VStack>
            </Stack>
            <Stack w="1/4">
              <VStack space="stack.quarck">
                <UI.Text variant="semibold" fontSize={Typography['fontsize.xs']}>
                  E-mail
                </UI.Text>
                <UI.Text color="neutral.darkest" variant="semibold">
                  {subscriptionCustomer.emailNormalized}
                </UI.Text>
              </VStack>
            </Stack>
          </HStack>
          <HStack justifyContent="space-between" alignItems="center">
            <Stack w="1/4">
              <VStack space="stack.quarck">
                <UI.Text variant="semibold" fontSize={Typography['fontsize.xs']}>
                  Qtde. Disponível
                </UI.Text>
                <UI.Text color="neutral.darkest" variant="semibold">
                  {`${subscriptionCustomer.availableQuantity}`}
                </UI.Text>
              </VStack>
            </Stack>
            <Stack w="1/2">
              <VStack space="stack.quarck">
                <UI.Text variant="semibold" fontSize={Typography['fontsize.xs']}>
                  Quantidade
                </UI.Text>
                <UI.InputStepper
                  max={subscriptionCustomer.availableQuantity}
                  min={1}
                  name="quantity"
                  defaultValue={quantity}
                  onChange={setQuantity}
                  stepperValue={1}
                  disabled={isDisabled}
                />
              </VStack>
            </Stack>
            <Stack w="1/4" alignItems="end">
              <HintButton
                tooltip={disabledMessage}
                variant="textLink"
                isDisabled={isDisabled}
                _text={{
                  color: 'brand.tertiary.principal',
                  fontFamily: Typography['fontfamily.base.semibold'],
                }}
                onPress={onSolicit}
                rightIcon={
                  <UI.Icon name="ChevronRight" size="xxxs" color="brand.tertiary.principal" />
                }>
                SOLICITAR
              </HintButton>
            </Stack>
          </HStack>
        </VStack>
      </Box>
    </UI.Shadow>
  );
};
